export const DEPOSIT_FUNDS_OPTIONS = [{ label: 'Deposit Crypto', value: 'depositCrypto' }];
